import Text from 'components/Text/Text';
import React from 'react';
import { IDishAllSubCategory } from 'types';
import style from './SubCategoriesScrollView.module.scss';

interface ISubCategoriesScrollView {
	data: IDishAllSubCategory[];
}

const SubCategoriesScrollView: React.FC<ISubCategoriesScrollView> = ({ data }) => {
	return (
		<div className={style.container}>
			{data.length
				? data.map((el) => (
						<div key={el.id} className={style.item}>
							<div className={style.dot} />
							<Text translationKey={el.subCategoryName} withTooltip={true} />
						</div>
				  ))
				: '-'}
		</div>
	);
};

export default React.memo(SubCategoriesScrollView);
